import { apiFetch } from '@/platform/lib/api';

export type MarketplaceVendorListing = {
  userId: string;
  handle?: string;
  displayName?: string;
  storeName: string;
  tagline?: string;
  verifiedAt?: string;
};

export function listMarketplaceVendors(params?: { cursor?: string; limit?: number }) {
  const q = new URLSearchParams();
  if (params?.cursor) q.set('cursor', params.cursor);
  if (params?.limit) q.set('limit', String(params.limit));
  const qs = q.toString();
  return apiFetch<{ vendors: MarketplaceVendorListing[]; nextCursor?: string }>(
    `/marketplace/vendors${qs ? `?${qs}` : ''}`,
  );
}

export function getMarketplaceVendor(userId: string) {
  return apiFetch<MarketplaceVendorListing>(`/marketplace/vendors/${userId}`);
}
